// Core map layer catalogue helpers. Kept as plain JS for CRA.

export const CATEGORIES = {
  soil: 'Soil type',
  'land-capability': 'Land capability',
  flood: 'Flood risk',
  'protected-sites': 'Protected sites',
  'nitrate-water': 'Nitrate and water zones',
};

// Order is the panel order, and the tie-break for overlay stacking in
// useLayerController. 'nitrate-water' is last: it is England-only, so on a
// Scottish or Welsh holding the list simply ends one item earlier.
export const CATEGORY_ORDER = [
  'soil',
  'land-capability',
  'flood',
  'protected-sites',
  'nitrate-water',
];

export function getActiveSources(category, region) {
  return category.sources.filter((source) => source.region === region);
}

export function isRenderable(source) {
  if (source.infoOnly) return false;
  if (source.licenceStatus !== 'verified') return false;

  // A source without the URL its kind needs can never render, so fail here
  // rather than at fetch time, where it would surface as a console error per
  // pan. These checks used to sit inside `if (source.unverified)`, which meant a
  // trusted WMS source that simply forgot `wmsBase` sailed through and failed
  // later, which is the exact outcome checking here exists to prevent. Verified
  // against the catalogue when this was widened: no current source changes.
  if (source.kind === 'arcgis-vector' && !source.serviceUrl) return false;
  if (source.kind === 'wms' && !source.wmsBase) return false;
  if (source.kind === 'arcgis-rest' && !source.serviceUrl) return false;
  if (source.kind === 'mvt-bbb' && !source.tileUrl) return false;

  return true;
}
